import React, { useState } from 'react';
import i18n from 'i18n';
import { EntityType, ObjectParamsItem, StateChangeType } from 'types/rest/assetCatalogTypes';
import ObjectParam from 'views/AssetCatalog/Transactions/TransactionEditor/ProcessingActions/stateChange/ObjectParam';
import { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import _ from 'lodash';
import NoContentPlaceholder from 'components/ui/noContentPlaceholder/NoContentPlaceholder';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import EntityModal from 'views/AssetCatalog/Transactions/TransactionEditor/ProcessingActions/stateChange/EntityModal';

interface ObjectParamsListProps {
  /** Parameters stored in the DSL state update DTO. */
  dataParams: ObjectParamsItem[] | null;
  onListChange: (list: ObjectParamsItem[]) => void;

  /** Parameters available in Blaze Data */
  availableDataParams: BlazeDropdownItem[];
  createEntityCallBack: (result: any) => void;
  showPlaceholder: boolean;
  entityType: EntityType;
  stateChangeType: StateChangeType;
}

const ObjectParamsList = (props: ObjectParamsListProps) => {
  const handleAddNew = () => {
    if (props.dataParams) {
      const list = _.cloneDeep(props.dataParams);
      list.push({ key: null, value: '' } as ObjectParamsItem);
      props.onListChange(list);
    }
  };

  const handleDelete = (index: number) => {
    if (props.dataParams) {
      const list = _.cloneDeep(props.dataParams);
      list.splice(index, 1);
      props.onListChange(list);
    }
  };

  const handleChange = (field: string, value: string | null, index: number) => {
    if (props.dataParams) {
      const list = _.cloneDeep(props.dataParams);
      if (field === 'key') {
        list[index].key = value;
      } else {
        list[index].value = value;
      }

      props.onListChange(list);
    }
  };

  if (props.showPlaceholder === true) {
    return (
      <div className={'bg-light mt-5 border-grey'}>
        <NoContentPlaceholder
          height={193}
          iconSize={'60px'}
          placeHolderContent={
            <Row className={'justify-content-center'}>
              <Col>
                <Row className={'justify-content-center'}>
                  <h2>{i18n.t('transactions:processingActions.modal.stateChange.dataParameters')}</h2>
                </Row>
                <Row>
                  <p>{i18n.t('transactions:processingActions.modal.stateChange.placeholder')}</p>
                </Row>
              </Col>
            </Row>
          }
        />
      </div>
    );
  } else {
    if (props.dataParams === null) {
      return <></>;
    }
    const length = props.dataParams.length;
    const emptyFilter = { value: '', showCreate: false, index: 0 };
    const [newFilter, setNewFilter] = useState(emptyFilter);

    return (
      <div className={'bg-light mt-5 p-5 border-grey'}>
        <label>{i18n.t('transactions:processingActions.modal.stateChange.selectDataParameters')}</label>
        <p>{i18n.t('transactions:processingActions.modal.stateChange.dataParametersDesc')}</p>
        {props.dataParams.map((oParamsItem: ObjectParamsItem, index: number) => {
          return (
            <>
              {/* TODO - refactor, it is not necessary to have so many instances of the modal, one should be enough */}
              {newFilter.showCreate && (
                <EntityModal
                  key={'createObjectParam-' + index}
                  availableItems={props.availableDataParams.map(dpl => dpl.name)}
                  itemName={newFilter.value}
                  closeModalAction={() => setNewFilter(emptyFilter)}
                  createEntityCallBack={(paramName: any) =>
                    props.createEntityCallBack({ key: paramName, index: newFilter.index })
                  }
                  entityType={props.entityType}
                />
              )}
              <ObjectParam
                stateChangeType={props.stateChangeType}
                onChange={handleChange}
                onAdd={handleAddNew}
                onDelete={handleDelete}
                displayAdd={index === length - 1 || length === 0}
                firstRow={index === 0}
                key={index}
                id={index}
                paramValue={oParamsItem}
                dataParamsList={props.availableDataParams ? props.availableDataParams : []}
                createEntityCallBack={props.createEntityCallBack}
                setModalValue={(entityValue: string) =>
                  setNewFilter({ value: entityValue, showCreate: true, index: index })
                }
                entityType={props.entityType}
              />
            </>
          );
        })}
      </div>
    );
  }
};

export default ObjectParamsList;
